import I18n from 'I18n';
import { useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { H2 } from 'foundations-components/transitional/components/H2';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Select } from 'foundations-components/components/Select';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { submitAdditionalPqlForm } from '../../../utils/pql';
import { getRepName } from '../../../utils/pql';
import { getTrackingProperties, track } from '../../../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MODAL_CLOSE_DELAY_MILLIS = 800;
export const EmailModal = ({
  apiName,
  onClose,
  repInfo,
  trackingData,
  upgradeConfig
}) => {
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [hasClickedSubmit, setHasClickedSubmit] = useState(false);
  const [pqlSubmissionStatus, setPqlSubmissionStatus] = useState('ready');
  const handleSubmit = () => {
    setHasClickedSubmit(true);
    if (subject.length && body.length) {
      setPqlSubmissionStatus('loading');
      submitAdditionalPqlForm({
        trackingData,
        apiName,
        isAssignable: true,
        isRetail: false,
        repInfo,
        options: {
          emailSubject: subject,
          emailBody: body
        }
      }).then(() => {
        setPqlSubmissionStatus('ready');
        track('communication-methods', Object.assign({
          action: 'submitted email message',
          repName: getRepName(repInfo)
        }, getTrackingProperties({
          apiName,
          trackingData,
          upgradeConfig,
          sourceKey: 'TALK_TO_SALES'
        })));
        setTimeout(() => {
          onClose();
        }, MODAL_CLOSE_DELAY_MILLIS);
      }).catch(() => {
        setPqlSubmissionStatus('failed');
      });
    }
  };
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "email-modal",
    width: 600,
    use: "conversational",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: () => onClose()
      }), /*#__PURE__*/_jsx(H2, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.emailModal.header"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.emailModal.subject"
        }),
        error: hasClickedSubmit && !subject.length,
        validationMessage: hasClickedSubmit && !subject.length && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.emailModal.errorMessages.subject"
        }),
        children: /*#__PURE__*/_jsx(Select, {
          selectedValues: subject ? [subject] : [],
          "data-test-id": "pql-email-subject-dropdown",
          searchable: false,
          onSelectedOptionChange: ({
            value
          }) => setSubject(value !== null && value !== void 0 ? value : ''),
          selectedItemsPlaceholder: I18n.text('purchaseMotions.talkToSales.communicationMethods.emailModal.subjectDropdown.placeholder')
          //The message subjects are submitted to 53 in English
          ,
          options: [{
            text: I18n.text(`purchaseMotions.talkToSales.communicationMethods.emailModal.subjectDropdown.options.purchase`),
            value: `I'm interested in purchasing a product`
          }, {
            text: I18n.text(`purchaseMotions.talkToSales.communicationMethods.emailModal.subjectDropdown.options.learnMore`),
            value: 'I want to learn more about a product or feature'
          }, {
            text: I18n.text(`purchaseMotions.talkToSales.communicationMethods.emailModal.subjectDropdown.options.help`),
            value: 'I need setup help or have a technical question'
          }, {
            text: I18n.text(`purchaseMotions.talkToSales.communicationMethods.emailModal.subjectDropdown.options.otherOption`),
            value: 'Other'
          }]
        })
      }), /*#__PURE__*/_jsx(FormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.emailModal.body"
        }),
        error: hasClickedSubmit && body === '',
        validationMessage: hasClickedSubmit && body === '' && /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.emailModal.errorMessages.body"
        }),
        children: /*#__PURE__*/_jsx(TextArea, {
          "data-test-id": "pql-email-message-textarea",
          placeholder: I18n.text('purchaseMotions.talkToSales.communicationMethods.emailModal.bodyPlaceholder'),
          rows: 10,
          resize: false,
          value: body,
          onChange: ({
            target: {
              value
            }
          }) => setBody(value)
        })
      }), pqlSubmissionStatus === 'failed' && /*#__PURE__*/_jsx(Alert, {
        titleText: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.expertTitle"
        }),
        type: "danger",
        marginBlockStart: "500",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.emailModal.submissionErrors.body"
        })
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(LoadingButton, {
        use: "primary",
        "data-test-id": "pql-email-submit",
        onClick: handleSubmit,
        loading: pqlSubmissionStatus === 'loading',
        keepResultAfterFinish: pqlSubmissionStatus !== 'failed',
        failed: pqlSubmissionStatus === 'failed',
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.emailModal.send"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "secondary",
        onClick: () => onClose(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "purchaseMotions.talkToSales.communicationMethods.emailModal.cancel"
        })
      })]
    })]
  });
};